import * as React from 'react'
import classnames from 'classnames'

import { Input, InputGroup, InputGroupText, InputGroupAddon } from 'reactstrap'

import CurrencyInput from 'react-currency-input'

const isEmpty = require('lodash/isEmpty')

type InputType = 'text' | 'number' | 'email' | 'tel' | 'date' | 'month' | 'textarea'

export interface InputCardProps {
  name?: string
  value?: string
  error?: boolean
  type?: InputType
  pattern?: string
  rightAddon?: any
  currency?: boolean
  className?: string
  inputMode?: string
  placeholder?: string
  onChange: (e) => void
  cardClassName?: string
}

class InputCard extends React.PureComponent<InputCardProps> {
  static defaultProps = {
    type: 'text'
  }

  renderCurrencyInput() {
    const { value, onChange, className, placeholder } = this.props

    return (
      <CurrencyInput
        prefix="$ "
        value={value}
        precision="2"
        placeholder={placeholder}
        className={classnames('form-control w-100', className)}
        onChangeEvent={e => {
          const newValue = (e.target.value || '').replace('$ ', '').replace(',', '')

          let floatValue: number|undefined
          if (!isEmpty(newValue)) {
            floatValue = parseFloat(newValue)
          }
          onChange(floatValue)
        }}
      />
    )
  }

  render() {
    const { name, type, error, value, pattern, onChange, currency, className, inputMode, placeholder, rightAddon, cardClassName } = this.props

    return (
      <div className={classnames('gginputcard p-2', { 'gginputcard--error': !!error }, cardClassName)}>
        <InputGroup>
          {currency
            ? this.renderCurrencyInput()
            : <Input
                type={type}
                name={name}
                value={value}
                pattern={pattern}
                onChange={onChange}
                className={className}
                inputMode={inputMode as any}
                placeholder={placeholder}
                style={{ height: '30px' }}
              />
          }

          {rightAddon &&
            <InputGroupAddon addonType="append">
              <InputGroupText>
                {rightAddon}
              </InputGroupText>
            </InputGroupAddon>
          }
        </InputGroup>
      </div>
    )
  }
}

export default InputCard



// WEBPACK FOOTER //
// ./src/common/InputCard.component.tsx